const Line = ({ testid, label, value, tone }) => (
  <div className="flex items-start justify-between gap-3 text-[10px]" data-testid={testid}>
    <span className="text-[#A3A3A3]">{label}</span>
    <span className="text-right" style={{ color: tone }}>{value}</span>
  </div>
);

const OK = "#22C55E", BAD = "#EF4444", WARN = "#F59E0B";
const DIAG_LABEL = {
  unprivileged: "lecture sans privilège (complète)",
  dedicated_utility: "utilitaire dédié vérifié",
  unprivileged_partial: "lecture sans privilège incomplète",
};

// Distingue : précheck Backend provisoire / Gateway / état autoritaire Raspberry / maintenance / autorisation finale.
export const OtaStatePhases = ({ readiness, expired }) => {
  const p = readiness?.phases;
  if (!p) return null;
  const pc = p.backend_precheck || {};
  const rs = p.raspberry_state || {};
  const finalOk = p.final?.deploy_allowed && !expired;
  return (
    <div className="space-y-1" data-testid="ota-state-phases">
      <Line testid="ota-phase-backend" label="Précheck Backend (provisoire)"
        value={pc.ok ? "aucun blocage détecté — ne prouve pas l'état physique" : `bloqué : ${(pc.reasons || []).join(", ")}`}
        tone={pc.ok ? "#A3A3A3" : BAD} />
      <Line testid="ota-phase-gateway" label="Télémétrie Gateway"
        value={p.gateway_state?.fresh ? "fraîche (≤ 8 s)" : "périmée — non autoritaire"} tone={p.gateway_state?.fresh ? OK : WARN} />
      <Line testid="ota-phase-raspberry" label="État local Raspberry (autoritaire)"
        value={rs.status === "SAFE" ? `sûr — ${rs.reason}` : rs.status === "UNSAFE" ? `non sûr — ${rs.reason}` : "non vérifiable"}
        tone={rs.status === "SAFE" ? OK : rs.status === "UNSAFE" ? BAD : WARN} />
      {p.maintenance_no_fc && (
        <Line testid="ota-phase-maintenance" label="Mode maintenance sans contrôleur de vol"
          value="validé par l'état local (FC/MAVLink absent, Raspberry idle)" tone={OK} />
      )}
      <Line testid="ota-phase-backup-diag" label="Diagnostic sauvegardes"
        value={(DIAG_LABEL[p.backup_diag?.source] || "indisponible")
          + (p.backup_diag?.partial ? ` — utilitaire dédié : ${p.backup_diag?.utility}` : "")}
        tone={p.backup_diag?.source && !p.backup_diag?.partial ? OK : WARN} />
      {p.backup_diag?.privilege_audit?.status === "WEAK" && (
        <Line testid="ota-phase-privileges" label="Droits sudo du compte SSH"
          value={`trop larges : ${(p.backup_diag.privilege_audit.findings || []).join(", ")}`} tone={WARN} />
      )}
      <Line testid="ota-phase-final" label="Autorisation finale de déploiement"
        value={finalOk ? "GO — revérifiée par le serveur à l'envoi" : expired ? "expirée — revérifier" : "NO-GO"}
        tone={finalOk ? OK : BAD} />
    </div>
  );
};
